// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"1d311e16","lsc":"432c09d2","others":"1fe3fc13"}[chunkId] + ".chunk.js";
};